export const ROLE = {
    SUPER_ADMIN: 'แอดมิน',
    OPERATION_TEAM: 'ทั่วไป'
}

export const STATUS = {
    active: 'เปิดใช้งาน',
    inactive: 'ปิด'
}
